module.exports = __webpack_public_path__ + "static/media/WAF_Protest_General2.f07450c7.jpg";